import axios from 'axios'
import * as Config from '../../config'

const state = {
    users: {
        current_page: 1,
        data:         [],
    },
    rating: {},
}

const actions = {

    StoreRating({commit, dispatch}, form) {
        commit('STORE_RATING')

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'assessment', form)
                .then(
                    response => {
                        if (response.data.code !== 500) {
                            commit('STORE_RATING_OK')
                            resolve(response.data)
                        } else {
                            commit('STORE_RATING_FAIL')
                            reject(response.data)
                        }

                    })
                .catch(error => {
                    commit('STORE_RATING_FAIL')
                    reject(error.data)
                })
        })


    },
}

const mutations = {

}

export default {
    state,
    actions,
    mutations
}
